'use client'
import { useEffect, useState } from 'react'
import i18next from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { getOptions, languages } from './settings'
import { initReactI18next, useTranslation as useTranslationOrg } from 'react-i18next'

const runsOnServerSide = typeof window === 'undefined'

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(resourcesToBackend(
    (language: string, namespace: string) => import(`./locales/${language}/${namespace}.json`))
  )
  .init({
    ...getOptions(),
    lng: undefined, // let detect the language on client side
    detection: {
      order: ['localStorage', 'navigator', 'cookie', 'path', 'htmlTag'],
    },
    preload: runsOnServerSide ? languages : []
  })

export function useTranslation(lng: string | null, ns: string[], options: object) {
  const ret = useTranslationOrg(ns, options)
  const { i18n } = ret

  const [activeLng, setActiveLng] = useState(i18n.resolvedLanguage)

  useEffect(() => {
    if (activeLng === i18n.resolvedLanguage) return
    setActiveLng(i18n.resolvedLanguage)
  }, [activeLng, i18n.resolvedLanguage])

  return ret
}